import { makeStyles } from '@material-ui/core';

export const GenericErrorStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'inherit',
    padding: theme.spacing(4),
    margin: theme.spacing(4),
    borderRadius: theme.spacing(2),
  },
  errorSubtitleContainer: {
    textAlign: 'center',
    margin: theme.spacing(2),
  },
  errorSubtitle: {
    color: '#FFFFFF',
    fontSize: theme.spacing(2),
    fontWeight: 'normal',
  },
  redirectContainer: {
    color: '#FFFFFF',
    margin: theme.spacing(2, 0),
  },
}));
